import { CommonModule } from '@angular/common';
import type { OnInit } from '@angular/core';
import { Component, ChangeDetectionStrategy, Input } from '@angular/core';
import { PalantirIconComponent } from '../icon/icon.component';
import type { PalantirIcon } from '../icon/icon.type';
import type { PalantirEmptyStateSize } from './empty-state.type';
import { PalantirEmptyStateSizeEnum } from './empty-state.type';

@Component({
  selector: 'palantir-empty-state',
  templateUrl: './empty-state.component.html',
  styleUrls: ['./empty-state.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: true,
  imports: [CommonModule, PalantirIconComponent],
})
export class PalantirEmptyStateComponent implements OnInit {
  @Input({ required: true }) public icon!: PalantirIcon;

  @Input() public size?: PalantirEmptyStateSize = PalantirEmptyStateSizeEnum.large;

  public ngOnInit(): void {
    this.size = this.size ?? PalantirEmptyStateSizeEnum.large;
  }
}
